import { Link, useLocation } from 'react-router-dom';
import '../styles/Breadcrumb.css';

const routeNames = {
  'pacientes': 'Pacientes',
  'facturacion': 'Facturación',
  'calendario': 'Calendario',
  'editar': 'Editar',
};

export default function Breadcrumb() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);

  return (
    <nav className="breadcrumb">
      <Link to="/dashboard">Panel</Link>
      {pathnames.map((segment, index) => {
        const routeTo = '/' + pathnames.slice(0, index + 1).join('/');
        const name = routeNames[segment] || segment;
        return (
          <span key={index}>
            {' > '}
            <Link to={routeTo}>{name}</Link>
          </span>
        );
      })}
    </nav>
  );
}
